import React from "react";
import { Form } from "react-bootstrap";

export const SelectField = ({ label = null, onChange, options, ...props }) => {
  return (
    <Form.Group>
      {label && (
        <Form.Label className="text-dark fw-semibold">{label}</Form.Label>
      )}
      <Form.Select className={props.className} onChange={onChange} {...props}>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};
